<template>
    <v-app>


        <v-divider color="#FFEA00" class="text-h3" style="border-width: 2px;"></v-divider>
        <v-card flat color="#1A237E" tile class="text-center">
            <!--<img src="@/assets/naniwa_logo.png" alt="Logo" class="header__logo">-->
            <v-container class="title">
                <v-row>
                    <v-col cols="1">
                        <img src="/naniwa_logo.png" alt="Logo" class="logo">
                    </v-col>
                    <v-col>
                        <v-card-text class=" yellow--text text--accent-3 text-center  text-h4">
                            荷物のお問い合わせ
                        </v-card-text>
                    </v-col>
                    <v-col cols="1">
                    </v-col>
                </v-row>

            </v-container>
        </v-card>
        <v-divider color="#FFEA00" style="border-width: 2px;"></v-divider>

        <v-container>
            <v-card elevation="0" min-height="900" tile>
                <v-card flat color="#E1F5FE">
                    <v-card-text class="black--text">
                        ご利用方法<br>
                        １．お問い合わせ番号を入力します（一度に１０件まで検索できます）<br>
                        ２．「検索を開始する」ボタンをクリックします<br>
                        ３．最新結果が表示されます（詳細情報は検索結果の伝票番号をクリックでご覧になれます）
                    </v-card-text>
                </v-card>
                <v-row class="pa-2">
                    <v-col cols="2">
                        <v-btn depressed block color="#0066FF" dark @click="onSearch()" width="10">
                            検索を開始する
                        </v-btn>

                    </v-col>
                    <v-col cols="2">
                        <v-btn depressed block color="#0066FF" dark @click="clearAll()" width="10">
                            クリアする
                        </v-btn>
                    </v-col>

                    <v-col cols="4">
                        <v-text>
                        </v-text>
                    </v-col>
                    <!--<v-col cols="1" class="ml-auto">
                    <v-btn depressed block color="#0066FF" dark class="ml-auto" @click="onClose()">
                        閉じる
                    </v-btn>
                </v-col>-->
                </v-row>
                <div>
                    <v-row no-gutters
                           style="height: 150px;">
                        <v-col v-for="n in 1"
                               :key="n">
                            <v-card class="text-center"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; border-top: 1px solid #616161; "
                                    color="#1A237E" dark
                                    tile>

                                <v-card-text class="white--text text-h6">
                                    お問い合わせ番号
                                </v-card-text>
                            </v-card>

                            <v-card class="pa-4"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161;"
                                    tile>
                                <!--1件目:-->
                                <v-text-field label="1件目"
                                              v-model="search_okurijo_number_1"
                                              hide-details="auto"
                                              maxlength="12"
                                              @keypress="validate"
                                              @keyup.enter="onSearch()"
                                              dense></v-text-field>
                            </v-card>
                            <v-card class="pa-4"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161;"
                                    tile>
                                <!--２件目-->
                                <v-text-field label="2件目"
                                              v-model="search_okurijo_number_2"
                                              hide-details="auto"
                                              maxlength="12"
                                              @keypress="validate"
                                              @keyup.enter="onSearch()"
                                              dense></v-text-field>
                            </v-card>
                            <v-card class="pa-4"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161;"
                                    tile>
                                <!--３件目-->
                                <v-text-field label="3件目"
                                              v-model="search_okurijo_number_3"
                                              hide-details="auto"
                                              maxlength="12"
                                              @keypress="validate"
                                              @keyup.enter="onSearch()"
                                              dense></v-text-field>
                            </v-card>

                            <v-card class="pa-4"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161;"
                                    tile>
                                <!--３件目-->
                                <v-text-field label="4件目"
                                              v-model="search_okurijo_number_4"
                                              hide-details="auto"
                                              maxlength="12"
                                              @keypress="validate"
                                              @keyup.enter="onSearch()"
                                              dense></v-text-field>
                            </v-card>

                            <v-card class="pa-4"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161;"
                                    tile>
                                <v-text-field label="5件目"
                                              v-model="search_okurijo_number_5"
                                              hide-details="auto"
                                              maxlength="12"
                                              @keypress="validate"
                                              @keyup.enter="onSearch()"
                                              dense></v-text-field>
                            </v-card>

                            <v-card class="pa-4"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161;"
                                    tile>
                                <v-text-field label="6件目"
                                              v-model="search_okurijo_number_6"
                                              hide-details="auto"
                                              maxlength="12"
                                              @keypress="validate"
                                              @keyup.enter="onSearch()"
                                              dense></v-text-field>
                            </v-card>

                            <v-card class="pa-4"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161;"
                                    tile>
                                <v-text-field label="7件目"
                                              v-model="search_okurijo_number_7"
                                              hide-details="auto"
                                              maxlength="12"
                                              @keypress="validate"
                                              @keyup.enter="onSearch()"
                                              dense></v-text-field>
                            </v-card>

                            <v-card class="pa-4"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161;"
                                    tile>
                                <v-text-field label="8件目"
                                              v-model="search_okurijo_number_8"
                                              hide-details="auto"
                                              maxlength="12"
                                              @keypress="validate"
                                              @keyup.enter="onSearch()"
                                              dense></v-text-field>
                            </v-card>

                            <v-card class="pa-4"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; "
                                    tile>
                                <v-text-field label="9件目"
                                              v-model="search_okurijo_number_9"
                                              hide-details="auto"
                                              maxlength="12"
                                              @keypress="validate"
                                              @keyup.enter="onSearch()"
                                              dense></v-text-field>
                            </v-card>

                            <v-card class="pa-4"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; "
                                    tile>

                                <v-text-field label="10件目"
                                              v-model="search_okurijo_number_10"
                                              hide-details="auto"
                                              maxlength="12"
                                              @keypress="validate"
                                              @keyup.enter="onSearch()"
                                              dense></v-text-field>

                            </v-card>
                        </v-col>
                        <v-col v-for="n in 1"
                               :key="n">
                            <v-card class="text-center"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; border-top: 1px solid #616161; "
                                    color="#1A237E" dark
                                    tile>
                                <v-card-text class="white--text text-h6">
                                    伝票検索結果
                                </v-card-text>
                            </v-card>

                            <v-card v-for="n in test2"
                                    :key="n"
                                    class="pa-2"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; "
                                    tile>
                            </v-card>
                            <v-card v-for="n  in search_result"
                                    :key="n"
                                    class="d-flex justify-center align-center"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; "
                                    tile>

                                <v-card class="text-h6 text-center"
                                        outlined
                                        style="border-color: white;"
                                        tile>
                                    <a @click="openDetail(n.okuriNo)"> {{n.okuriNo}}</a>
                                </v-card>
                            </v-card>
                        </v-col>
                        <v-col v-for="n in 1"
                               :key="n">
                            <v-card class="text-center"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; border-top: 1px solid #616161; "
                                    color="#1A237E" dark
                                    tile>
                                <v-card-text class="white--text text-h6">
                                    登録日時
                                </v-card-text>
                            </v-card>

                            <v-card v-for="n in test2"
                                    :key="n"
                                    class="pa-2"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161;"
                                    tile>
                            </v-card>
                            <v-card v-for="n in search_result"
                                    :key="n"
                                    class="d-flex justify-center align-center"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; "
                                    tile>

                                <v-card class="text-h6 text-center"
                                        outlined
                                        style="border-color: white;"
                                        tile>
                                    {{n.sysDate}}
                                </v-card>
                            </v-card>



                        </v-col>
                        <v-col v-for="n in 1"
                               :key="n">
                            <v-card class="text-center"
                                    flat
                                    color="#1A237E" dark
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; border-right: 1px solid #616161; border-top: 1px solid #616161 "
                                    tile>
                                <v-card-text class="white--text text-h6">
                                    最新情報
                                </v-card-text>
                            </v-card>

                            <v-card v-for="n in test2"
                                    :key="n"
                                    class="pa-2"
                                    height="60px"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; border-right: 1px solid #616161;"
                                    tile>

                            </v-card>
                            <v-card v-for="n  in search_result"
                                    :key="n"
                                    height="60px"
                                    class="d-flex justify-center align-center"
                                    flat
                                    style="border-bottom: 1px solid #616161; border-left: 1px solid #616161; border-right: 1px solid #616161;"
                                    tile>
                                <v-card class="text-h6 text-center"
                                        outlined
                                        style="border-color: white;"
                                        tile>
                                    {{n.shubetsu}}
                                </v-card>

                            </v-card>

                        </v-col>
                    </v-row>
                    <!--</v-container>-->
                </div>
            </v-card>
            <!--<p class="pa-2" color="#990033">詳細情報は検索結果欄の伝票番号をクリックでご覧いただけます</p>-->
        </v-container>


        <div>
            <v-dialog v-model="is_open_dialog_edit"
                      width="90%">
                <v-card>
                    <v-card flat color="#E1F5FE">
                        <v-card-text class="black--text text-center  text-h6">
                            詳細情報&nbsp;{{select_number}}件目&nbsp;&nbsp;伝票番号:&nbsp;&nbsp;{{select_okuri_no}}
                        </v-card-text>
                    </v-card>

                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-data-table dense
                                              :headers="headers"
                                              :items="select_number_data"
                                              :page.sync="detail_page"
                                              @page-count="detail_page_count=$event"
                                              class="my-data-table elevation-1 ml-1 mr-1 mt-3 "
                                              :items-per-page="-1"
                                              :width="$vuetify.breakpoint.width"
                                              disable-sort
                                              hide-default-footer>
                                    <template slot="no-data">
                                        <div><p v-if="nodata_nifuda==1">該当するデータがありません。</p></div>
                                    </template>

                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row class="my-2">


                            <v-spacer></v-spacer>
                            <v-btn color="#0066FF" dark
                                   class="mx-2"
                                   @click="is_open_dialog_edit = false">
                                閉じる
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
        <v-footer color="#1A237E" dark app>
            浪速運送株式会社
        </v-footer>

        <v-dialog persistent width="400" :value="is_loading">
            <v-card color="primary darken-2" dark>
                <v-card-text>
                    しばらくお待ちください......
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>

    import { mapState } from 'vuex';

    export default {
        data: () => ({


            search_condition: {
                okurijo_number: '',
            },

            search_okurijo_number_1: '',
            //search_okurijo_number_2: '141038051694',
            /*search_okurijo_number_1: '',*/
            search_okurijo_number_2: '',
            search_okurijo_number_3: '',
            search_okurijo_number_4: '',
            search_okurijo_number_5: '',
            search_okurijo_number_6: '',
            search_okurijo_number_7: '',
            search_okurijo_number_8: '',
            search_okurijo_number_9: '',
            search_okurijo_number_10: '',

            search_param: {},

            ref_data: [],
            search_result: [],
            test: 0,
            test2: 10,
            test_str: '',
            search_okurijo_list_1: '',

            result_data_1: {
                okuriNo: '',
                sysDate: '',
                shubetsu: '',
            },

            is_open_dialog_edit: false,
            is_loading: false,

            headers: [
                {
                    width: '70px', text: '登録日時', align: 'start', value: 'sysDate', class:'white--text'},
                {
                    width: '150px', text: '状況', align: 'start', value: 'shubetsu', class: 'white--text' },
                {
                    width: '50px', text: 'お取り扱いセンター', align: 'start', value: 'center', class: 'white--text'},
                {
                    width: '50px', text: 'お問い合わせ先電話番号', align: 'start', value: 'center_tel', class: 'white--text'},

            ],

            select_number_data: [],

            select_number: '',
            select_okuri_no: '',

            input_number_list: [],
            /*img_name:'C:/develop/naniwa/transport-service/src/TransportService.Server/Img/naniwa_logo.png',*/
            img_name: './naniwa_logo.png',

        }),

        computed: {
            ...mapState({
                cmn_store: state => state.common_store,
            }),
        },

        methods: {
            async onSearch() {
                //this.test2 = 10;
                //this.ref_data = [];
                //this.search_result = [];
                //this.select_number_data = [];

                try {

                    this.is_loading = true;
                    document.activeElement.blur();

                    this.input_number_list = [];
                    this.input_number_list.push(this.search_okurijo_number_1)
                    this.input_number_list.push(this.search_okurijo_number_2)
                    this.input_number_list.push(this.search_okurijo_number_3)
                    this.input_number_list.push(this.search_okurijo_number_4)
                    this.input_number_list.push(this.search_okurijo_number_5)
                    this.input_number_list.push(this.search_okurijo_number_6)
                    this.input_number_list.push(this.search_okurijo_number_7)
                    this.input_number_list.push(this.search_okurijo_number_8)
                    this.input_number_list.push(this.search_okurijo_number_9)
                    this.input_number_list.push(this.search_okurijo_number_10)

                    let msg = this.checkInvalidOkurijo(this.input_number_list);
                    if (msg !== 'OK') {
                        this.msg_error_dialog(msg ?? '入力された数字が不正です。');
                        return;
                    }

                    this.search_param = this.search_condition;
                    this.search_param.okurijo_number = this.search_okurijo_number_1 + ',' + this.search_okurijo_number_2 + ',' + this.search_okurijo_number_3 + ',' + this.search_okurijo_number_4 + ',' + this.search_okurijo_number_5 + ',' + this.search_okurijo_number_6 + ',' + this.search_okurijo_number_7 + ',' + this.search_okurijo_number_8 + ',' + this.search_okurijo_number_9 + ',' + this.search_okurijo_number_10;

                    if (this.search_param.okurijo_number == ",,,,,,,,,") {
                        this.test = 0;
                    } else {

                        this.test2 = 10;
                        this.ref_data = [];
                        this.search_result = [];
                        this.select_number_data = [];

                        var params = new URLSearchParams();
                        params.append('param', JSON.stringify(this.search_param));
                        let res = await this.axios_post_noloading('/CargoInquiry/SearchNumber', params);
                        this.is_open_dialog_edit = false;


                        if (res.data.status == 'OK') {
                            this.ref_data = res.data.tsuisekiList2;
                            for (var i = 0; i < this.ref_data.length; i++) {

                                /*this.search_result.push(this.ref_data[i][this.ref_data[i].length - 1]);*/

                                if (this.input_number_list[i].length != 12 && this.input_number_list[i] != '') {
                                    this.search_result.push({ okuriNo: this.input_number_list[i], sysDate: '', shubetsu: '該当なし' });
                                } else if (this.ref_data[i].length === 0) {
                                    this.search_result.push({ okuriNo: this.input_number_list[i], sysDate: '', shubetsu: '該当なし' });
                                } else {
                                    this.search_result.push(this.ref_data[i][this.ref_data[i].length - 1]);
                                }
                            }
                            this.test = 1;
                            this.test2 = 0;
                        } else {
                            /*this.ref_data = ['エラーが発生しました'];*/
                            this.msg_error_dialog(res.data.errMessage ?? '検索中にエラーが発生しました');
                        }

                    }
                } catch (e) {
                    this.msg_error_dialog(e);
                } finally {
                    this.is_loading = false;
                }
            },

            openDetail(event) {
                this.select_okuri_no = event;
                this.is_open_dialog_edit = false;
                for (var i = 0; i < this.ref_data.length; i++) {
                    if (this.ref_data[i].length > 0 && this.select_okuri_no == this.ref_data[i][0].okuriNo) {
                        this.select_number_data = this.ref_data[i];
                        this.select_number = i + 1;
                        this.is_open_dialog_edit = true;
                        break;
                    }
                }              
            },

            clearAll() {
                this.search_okurijo_number_1 = '';
                this.search_okurijo_number_2 = '';
                this.search_okurijo_number_3 = '';
                this.search_okurijo_number_4 = '';
                this.search_okurijo_number_5 = '';
                this.search_okurijo_number_6 = '';
                this.search_okurijo_number_7 = '';
                this.search_okurijo_number_8 = '';
                this.search_okurijo_number_9 = '';
                this.search_okurijo_number_10 = '';
                this.search_result = [];
                this.test2 = 10;


            },

            onClose() {
                /*window.open("", "_blank", "");*/
                window.close();

            },

            validate(e) {
                const charCode = (e.which) ? e.which : e.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) { // 数字入力のみ許可する
                    e.preventDefault();
                } else {
                    return true;
                }
            },

            // 数字以外があるかチェック
            checkInvalidOkurijo(list) {

                const invalidIndexes = list
                    .map((str, i) => ({ str, index: i }))
                    .filter(x => x.str !== '' && !/^[0-9]+$/.test(x.str))
                    .map(x => x.index + 1); // 1始まりにする

                if (invalidIndexes.length === 0) {
                    return 'OK';
                }
                return invalidIndexes.join("、") + "件目のお問い合わせ番号には数字のみ入力してください";
            },

        }

    };
</script>

<style>
    #app {
        /*font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;*/
        /*color: #3333CC;*/
        color: #000080;
        /*background-color: #003399;*/
        /*margin-top: 60px;*/
    }

 
    .v-data-table thead {
        background-color: #000080;
        text-emphasis-color: #FFFF66;
    }

    .v-data-table-header th {
        color: #FFFF66;
    }

    .custom-card {
        border: 2px solid red; /* アウトラインの色を赤に変更 */
    }

    .aaa {
        border-color: #FFFF66;
    }
     /*v-text-field type=number*/ /*スピンボタン非表示 */
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        /*appearance: none;*/
        margin: 0;
    }

    input[type="number"] {
        -moz-appearance: textfield;
        /*appearance: textfield;*/
    }
</style>
